<template>
<div class="main-content" id="dashboard">
  <!-- <div v-if="!loading">
    <button v-on:click="saveUser">
      Save
    </button>
    <div>
      <ul>
        <li v-for="(group, index) in current.membership.groups" :key="index" @click="removeGroup(group.id)">
          {{ group.name }}
        </li>
      </ul>

      <ul>
        <li v-for="(group, index) in groups" :key="index" @click="addGroup(group.id)">
          {{ group.name }} {{ group.id }}
        </li>
      </ul>
    </div>
  </div>
  <div v-else>
    <div v-if="_isLoadingContext() || _isLoadingGroups() || !_isLoadingMembers()">Fetching data...</div>
    <div v-if="_isUpdatingUser()">Updating user, please wait...</div>
  </div> -->
    <Pagetitle main-title="Dashboard" sub-title="Get started with your workspace" av-icon="dashboard" color="blue"></Pagetitle>
    <div class="row">
        <div class="col-lg-4">
            <Card card-title="Get started with Apostle Connect">
                <ProgressBar :percentage=percentage />
                <Selectable :key="index" v-for="(selectable, index) in selectables" :checked="selectable.checked">
                    <template v-slot:icon><svgicon :name="selectable.icon" /></template>
                    <template v-slot:title-text>{{selectable.title}}</template>
                    <template v-slot:label-text>{{selectable.subtitle}}</template>
                </Selectable>
            </Card>
        </div>
        <div class="col-lg-4">
            <Card card-title="Improve your approach for a better reach" variant="cta"></Card>
        </div>
        <div class="col-lg-4">
            <Card card-title="Planning"></Card>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-4">
             <Card card-title="Users"></Card>
         </div>
        <div class="col-lg-4">
            <Card card-title="Recent activity"></Card>
        </div>
        <div class="col-lg-4">
            <Card card-title="Content strategy"></Card>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Card from "../../components/Card/Card";
import Pagetitle from "../../components/Pagetitle/Pagetitle";
import Selectable from "../../components/Selectable/Selectable";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import Context from "@/models/Context";
import Group from "@/models/core/Group";

export default {
    name: 'dashboard',
    components: {
        Pagetitle,
        Card,
        Selectable,
        ProgressBar
    },
    props: [],
    data () {
        return {
            percentage: 40,
            selectables: [
                {
                    title: "Choose an avatar",
                    subtitle: "App. 3 mins",
                    icon: "accounts",
                    checked: false
                },
                {
                    title: "Create groups",
                    subtitle: "App. 6 mins",
                    icon: "groups",
                    checked: false
                },
                {
                    title: "Create themes",
                    subtitle: "App. 10 mins",
                    icon: "goal",
                    checked: true
                },
                {
                    title: "Invite other users",
                    subtitle: "App. 4 mins",
                    icon: "people",
                    checked: true
                },
                {
                    title: "Make your first post",
                    subtitle: "App. 5 mins",
                    icon: "create",
                    checked: false
                },
            ]
        }
    },
    computed: {
      current() {
        if(!this._isLoadingContext()) {
          return Context.query()
                .where(context => {
                  return context.id === 'current';
                })
                .with('user')
                .first();
        } else {
          return null;
        }
      },

      loading() {
          return this._isLoading();
        },

      groups() {
        if(!this._isLoadingGroups()) {
          const groups =Group.all().filter((group, index, arr) => {
            return !(this.current.membership.groups_collection.indexOf(group.id) > -1);
          });

          return groups;
        } else {
          return null;
        }
      }
    },
    created() {
      this._findGroups();
    },
    mounted () {

    },
    methods: {
      ...mapActions({
        _updateUser: 'entities/users/update',
        _findGroups: 'entities/groups/findForTeam',
        _updateContext: 'entities/context/testUpdate',
        _removeContext: 'entities/context/testRemove'
      }),
      ...mapGetters({
        _isLoading: 'isLoading',
        _isLoadingContext: 'entities/context/isLoading',
        _isLoadingMembers: 'entities/memberships/isLoading',
        _isLoadingGroups: 'entities/groups/isLoading',
        _isUpdatingUser: 'entities/users/isUpdating',
      }),
      addGroup(value) {
        this._updateContext(value);
      },
      removeGroup(value) {
        this._removeContext(value);
      },
      saveUser() {
        this._updateUser(this.current.user);
      }
    }
}
</script>
<style src="./Dashboard.scss" scoped lang="scss"></style>
